<template>
  <div v-if="data">
    <van-popup
      v-model="show"
      position="bottom"
      round
      class="my-popup"
      @close="bindClose"
    >
      <div class="toast-container">
        <img
          class="flower-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a1189f68776f9d3a5d84116f75feaac9.png"
          alt=""
        />
        <div class="title">奖励</div>
        <div class="prize-box">
          <div class="prize-name">{{ data.reward_name }}</div>
          <div class="prize-desc">{{ data.reward_description }}</div>
          <div class="prize-image-content">
            <img class="prize-image" :src="data.reward_image_url" alt="" />
          </div>
        </div>
        <div class="tips">奖励以优惠券的形式发放，点击下方按钮立刻使用</div>
        <div
          class="btn"
          :class="{ 'btn-disabled': !data.reach_type }"
          @click="bindReceive"
        >
          {{ btnText }}</div
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    value() {
      this.show = this.value
    }
  },
  computed: {
    btnText() {
      if (!this.data) {
        return ''
      }
      if (!this.data.reach_type) {
        return '未达领取条件'
      } else if (!this.data.received_status) {
        return '去使用'
      } else {
        return '查看'
      }
    }
  },
  created() {
    this.show = this.value
  },
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    bindReceive() {
      this.$emit('receive', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-popup {
  overflow-y: visible;
}

.toast-container {
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(255, 240, 243, 1) 0%,
    rgba(229, 227, 255, 1) 100%
  );
  padding: 70px 30px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  .flower-image {
    width: 125px;
    height: 90px;
    position: absolute;
    transform: translate(-50%, 0%);
    left: 50%;
    top: -30px;
  }

  .title {
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 33px;
    margin-bottom: 10px;
  }

  .prize-box {
    width: 315px;
    height: 160px;
    padding: 20px 0px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: #fff;
    margin-bottom: 16px;
    .prize-name {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 16px;
    }

    .prize-desc {
      margin-top: 7px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 16px;
    }
    .prize-image-content {
      margin-top: 7px;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }
    .prize-image {
      object-fit: contain;
      max-width: 138px;
      max-height: 100%;
    }
  }

  .tips {
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 10px;
  }

  .btn {
    text-align: center;
    width: 225px;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
    border-radius: 24px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #ffffff;
  }

  .btn-disabled {
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>
